<template>
  <div class="container">
    <div class="block">
      <div class="title-wrap">
        <div class="title-name">
          <em @click="$router.push({ name: 'cloudServerManager' })"
            >沙盒服务器管理</em
          >
          <label
            ><i class="el-icon-arrow-right"></i> {{ $route.meta.title }}</label
          >
        </div>
      </div>
      <div class="content-inner-wrapper">
        <!-- <el-radio-group class="records" v-model="status" size="mini">
          <el-radio-button label=0>提现记录</el-radio-button>
          <el-radio-button label=1>消费记录</el-radio-button>
        </el-radio-group> -->
        <el-form label-width="76px">
          <el-form-item label="货币类型">
            <el-radio-group
              class="paymentType"
              v-model="paymentType"
              size="mini"
            >
              <el-radio-button label="0">全部</el-radio-button>
              <el-radio-button label="4">支付宝</el-radio-button>
              <el-radio-button label="3">微信</el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-form>
        <div class="tablePreHeader">
          <div class="query-form">
            <el-form
              :inline="true"
              ref="workForm"
              :rules="rules"
              :model="formInline"
              class="form-inline"
            >
              <el-form-item
                label="选择日期"
                prop="date"
                style="margin-right: 0"
              >
                <el-date-picker
                  v-model="formInline.date"
                  type="daterange"
                  unlink-panels
                  range-separator="至 "
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :picker-options="pickerOptions"
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item>
                <div class="btn-query" @click="queryTableFn">查找</div>
              </el-form-item>
            </el-form>
          </div>
          <div class="download-wrap" @click="exportFn">
            <img src="../../images/pc/icon_export.png" />
            <span>导出详细数据</span>
          </div>
        </div>
        <div class="myTable-wrap">
          <el-table :data="orderList" stripe>
            <el-table-column
              align="center"
              prop="id"
              label="订单号"
              width="160"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="create_time"
              label="日期"
              width="160"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.create_time | formatTime }}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="player_max" label="服务器规格">
              <template slot-scope="scope">
                <span>{{ scope.row.player_max }}人</span>
              </template>
            </el-table-column>
            <!-- <el-table-column
              align="center"
              prop="servType"
              label="服务器类型">
            </el-table-column> -->
            <el-table-column prop="day" label="购买时长">
              <template slot-scope="scope">
                <span>{{ scope.row.day }}天</span>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="buy_count" label="购买数量">
            </el-table-column>
            <el-table-column align="center" prop="money" label="金额">
              <template slot-scope="scope">
                <span>{{ scope.row.money | twoDigit }}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="buy_type" label="支付方式">
              <template slot-scope="scope">
                <span>{{ scope.row | payType }}</span>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="operation_type"
              label="订单类型"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.operation_type | orderType }}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="state" label="交易状态">
              <template slot-scope="scope">
                <span>{{ scope.row.state | orderState }}</span>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="option"
              width="120px"
              fixed="right"
              label="操作"
            >
              <template slot-scope="scope">
                <el-link
                  type="primary"
                  @click="
                    $router.push({
                      name: 'cloudServerOrderDetails',
                      params: { order: scope.row, id: scope.row.id },
                    })
                  "
                  >查看详情</el-link
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="data-filter-page">
          <el-pagination
            background
            layout="prev, pager, next, jumper"
            :total="pagination.total"
            @current-change="paginationChange"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import mixins from '../../mixins/orderList.mixins';
import { cloudApi } from '../../api/index';
import { ONE_DAY } from '../../base/CONST';
const { exportCloudOrderList } = cloudApi;
export default {
  mixins: [mixins],
  data() {
    return {
      rules: {
        date: [{ required: true, message: '请选择日期', trigger: 'blur' }],
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      //购买记录页曝光埋点
      this.$log('record_purchase_show', 85439, { v7: 1 });
    },
    exportFn() {
      return exportCloudOrderList({
        start_time: Math.floor(this.formInline.date[0] / 1000),
        end_time: Math.floor((+this.formInline.date[1] + ONE_DAY) / 1000 - 1),
      }).then(res => {
        if (res.code === 0) {
          location.href = res.data.url; // TODO
        }
      });
    },
  },
};
</script>
<style src="../../style/common-pc.scss" lang="scss" scoped></style>
<style lang="scss" scoped>
.el-radio-group {
  margin-bottom: 15px;
  &.paymentType {
    margin-bottom: 0;
  }
  .el-radio-button {
    margin-right: 12px;
    ::v-deep .el-radio-button__inner {
      font-size: 14px;
      box-shadow: none;
      width: 88px;
      height: 31px;
      border-radius: 4px;
      border: 1px solid #d9d9d9;
      color: #262626;
    }
    ::v-deep &.is-active {
      .el-radio-button__inner {
        border-color: #ffc973;
        background-color: #fffaed;
        color: #fd9b21;
      }
    }
  }
}
::v-deep .el-radio-button__orig-radio:checked + .el-radio-button__inner {
  border-color: #ffc973;
  background-color: #fffaed;
  color: #fd9b21;
}
.el-form-item {
  margin-bottom: 15px;
}
.query-form {
  margin-bottom: 5px;
}
.el-table {
  .el-link {
    color: #50a3f1;
  }
}
</style>
